import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBotswana = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_29_255)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M0.566686 8.34778C0.199092 9.49946 1.41684e-05 10.7263 6.10434e-05 12C1.41684e-05 13.2735 0.199092 14.5004 0.566733 15.6521L12.0001 16.1739L23.4333 15.6521C23.8009 14.5004 24 13.2735 24 12C24 10.7264 23.8009 9.49946 23.4333 8.34778L12 7.82607L0.566686 8.34778Z",
				fill: "#F0F0F0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M24 12C24 11.2881 23.9377 10.5908 23.8187 9.91299H0.181313C0.0623437 10.5908 0 11.288 0 12C0 12.7119 0.0623906 13.4091 0.181313 14.0869H23.8187C23.9376 13.4091 24 12.7118 24 12Z",
				fill: "black"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M12 23.9999C17.3539 23.9999 21.8881 20.4936 23.4333 15.6521H0.566711C2.11195 20.4935 6.64621 23.9998 12 23.9999Z",
				fill: "#338AF3"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M12 4.57782e-05C6.6462 4.57782e-05 2.11198 3.50643 0.56665 8.34778L23.4332 8.34782C21.8881 3.50643 17.3538 -4.79717e-05 12 4.57782e-05Z",
				fill: "#338AF3"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_29_255",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "white"
		})
	}) })]
});
export default SvgBotswana;
